var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { style: _vm.getStyle, attrs: { id: "skillsCard" } },
    [
      _c("div", {
        staticClass: "overlayed",
        style: _vm.images[0][2].exists
          ? _vm.images[0][2].custom
          : _vm.images[0][2].default,
      }),
      _vm._v(" "),
      _c("vx-card", [
        _c("h2", { staticClass: "mb-2" }, [
          _vm._v("\n      Compétences\n      "),
        ]),
        _vm._v(" "),
        _c("ul", { staticStyle: { "min-height": "50px" } }, [
          _c("li", [
            _c(
              "a",
              {
                staticClass: "link",
                attrs: {
                  name: "cardCompetence",
                  href: "/rh/referentiel/competences",
                },
              },
              [_vm._v("Consulter une compétence")]
            ),
          ]),
          _vm._v(" "),
          _c("li", [
            _c(
              "a",
              {
                staticClass: "link",
                attrs: {
                  name: "cardEntreeCompetence",
                  href: "/rh/gestion/tableaux/competences",
                },
              },
              [_vm._v("Rechercher une compétence")]
            ),
          ]),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }